import { UPDATE_LASTID } from "./actionTypes";

export const updateLastID = (value) => {
    return {
        type: UPDATE_LASTID,
        payload: value
    };
};